import React from "react";
import { Box, useMediaQuery, useTheme, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImageSlider from "./imageSlider";
import { Images } from "../../../utils/Images";
import "../../../styles/desktop/pages/index.css"

const AuthenticationLeftContent = ({ onClose, showCloseButton = true }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  const isLaptop = useMediaQuery(theme.breakpoints.down("lg"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  // Example data for slides - can be fetched from API or props
  const slideImages = [Images.loginLeftBg1, Images.loginLeftBg2, Images.loginLeftBg3, Images.loginLeftBg4];
  const slideTitles = [
    "Thank you for donating", 
    "Your support brings a smile today", 
    "Thank you - Your support lights up dark days",
    "Thank you - Together, we are changing lives"
  ];
  const slideSubtitles = [
    "Every donation brings a smile", 
    "Every donation brings a smile", 
    "Every donation brings a smile",
    "Every donation brings a smile",
  ];

  // Custom dot design for mobile to match web design
  const customAppendDots = (dots) => (
    <Box

      sx={{
        position: "absolute",
        bottom: "14px",
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        justifyContent: "center",
        zIndex: 2,
        background: "rgba(255, 255, 255, 0.10)",
        backdropFilter: "blur(50px)",
        padding: "4px 8px",
        borderRadius: "20px",
        width: "fit-content",
        margin: "auto",
        "& ul": {
          margin: 0,
          padding: 0,
          display: "flex",
          gap: "4px",
        },
        "& li": {
          width: "auto !important",
          height: "auto !important",
          margin: "0 4px",
        },
      }}
    >
      {dots}
    </Box>
  );

  const customCustomPaging = (i) => (
    <Box
      sx={{
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: "#D9D9D9",
      }}
    />
  );

  // Example: Custom settings for this page only
  const customSliderSettings = {
    autoplay: true,
    dots: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    arrows: false,
    // Override the dot styling for mobile to match web design
    appendDots: customAppendDots,
    customPaging: customCustomPaging,
  };

  return (
    <Box
    className="authentication-left-content"
     sx={{ 
      width: "100%", 
      maxWidth: isMobile ? "100%" : isTablet ? "100%" : isLaptop ? "100%" : "499px", 
      height: isMobile ? "50vh" : isTablet ? "40vh" : "100%",
      minHeight: isMobile ? "250px" : isTablet ? "250px" : isLaptop ? "335px" : "100%",
      maxHeight: isMobile ? "50vh" : isTablet ? "40vh" : "100%",
      borderRadius: isMobile ? "12px 12px 0 0" : isTablet ? "12px 12px 0 0" : "0",
      // For medium screens (500px-900px), limit the size
      ...(isMediumScreen && !isTablet && {
        maxWidth: "390px",
        margin: "0 auto" // Center the slider
      }),
      // Target the dots specifically for this component
      "& .slick-dots": {
        position: "absolute",
        bottom: "14px",
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        justifyContent: "center",
        zIndex: 2,
        background: "rgba(255, 255, 255, 0.10)",
        backdropFilter: "blur(50px)",
        padding: "4px 8px",
        borderRadius: "20px",
        width: "fit-content",
        margin: "auto",
      },
      "& .slick-dots ul": {
        margin: 0,
        padding: 0,
        display: "flex",
        gap: "4px",
      },
      "& .slick-dots li": {
        width: "auto !important",
        height: "auto !important",
        margin: "0 4px",
      },
      "& .slick-dots li.slick-active div": {
        backgroundColor: "#A9C74E",
        width: "6px",
        height: "6px",
      },
    }}>
      {/* Close button for mobile/tablet */}
      {(isMobile || isTablet) && showCloseButton && (
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: "16px",
            right: "16px",
            backgroundColor: "#000000",
            color: "#FFFFFF",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            zIndex: 10,
            "&:hover": {
              backgroundColor: "#333333",
            }
          }}
        >
          <CloseIcon sx={{ fontSize: "18px" }} />
        </IconButton>
      )}
      <ImageSlider
        images={slideImages}
        titles={slideTitles}
        subtitles={slideSubtitles}
        settings={customSliderSettings}
        noPaddingRight={true}        
        imgSx={{
          height: "100%", 
          objectFit: "cover",
          width: "100%",
        }}
        
      />
    </Box>
  );
};

export default AuthenticationLeftContent;